import { Outlet, Link } from "react-router-dom";
import css from './home.css'
import Bell from '../img/bell.png'
import quit from '../img/quit.png'
import { change } from '../slicers/selectedStepSlicer'
import {useDispatch, useSelector } from 'react-redux';
import Get_employee from '../apiCalls/employee_call.js';
import { useEffect } from "react";
import Cookies from 'universal-cookie';
const cookies = new Cookies(null, { path: '/' });

//  Функция для пересчёта UTC → Екатеринбург (+5 часов)
const toEkaterinburgTime = (dateString) => {
    const date = new Date(dateString);
    date.setHours(date.getHours() + 5);
    return date;
};

const Home = () => {
    const dispatch = useDispatch()
    window.onscroll = function() {ScrollFunction()}
    Get_employee()
    console.log(new Date().getDate)
    const date = new Date(); 
    const monthNameRussian = new Intl.DateTimeFormat('ru-RU', { month: 'long' }).format(date);
    const employeeSlicer = useSelector((state) => state.employeeSlicer.arr)  
    function ScrollFunction() { 
        if (document.documentElement.scrollTop > 470) {
            document.getElementsByClassName('header_scroled')[0].style.display = 'inline-flex'
            
        } else {
            document.getElementsByClassName('header_scroled')[0].style.display = 'none'
    }}

    function exit() { 
        cookies.set('privateToken', '');
        window.location.reload();
    }
  return (
    <>
    <div  className="header_background font1">
        <div className="grid-2">
            <div style={{display:'inline-flex'}}>
                <div className="ball_avatar"></div>
                <div className="exit_cont" style={{position:'fixed', right:'12px', top:'12px'}}   onClick={() => {exit()}}><img  style={{width:'27px'}} src={quit}></img></div>
                <p className="font4">{employeeSlicer?.name + ' ' + (employeeSlicer?.secondName?.[0] === undefined ? '': employeeSlicer?.secondName?.[0] + '.') + (employeeSlicer?.patronymic?.[0] === undefined ? '': employeeSlicer?.patronymic?.[0] + '.')}</p>
            </div>
        </div>
        <div className="felxBox-3">
            <a className="add" onClick={() => {dispatch(change(1))}}>ДОБАВИТЬ ОПЕРАЦИЮ</a>
        </div>

    </div>
    <p className="font5" style={{}}>ПОСЛЕДНИЕ ОПЕРАЦИИ</p>
    {employeeSlicer?.latestOperations
    ?.slice()
    .sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime))
    .map((job) => {
        
        // 🔥 Получаем дату операции в екатеринбургском времени
        const ekbDate = toEkaterinburgTime(job.dateTime);
        const today = toEkaterinburgTime(new Date().toISOString());
        
        return (
        <div className="flexBox-gen" key={job.id}>
            <div className="grid-2 task_row">
                <div>
                    <p className="task_name">{job.name}</p>
                    {job.workOrderNumber && (
                        <p className="task_order" style={{color: '#5F6770', fontSize: '12px', margin: '2px 0'}}>
                            Заказ №{job.workOrderNumber}
                            {job.workOrderDate && (
                                <> от {toEkaterinburgTime(job.workOrderDate).toLocaleDateString('ru-RU')}</>
                            )}
                        </p>
                    )}
                    <p className="task_done">Станок №{job.machineNumber}</p>
                </div>
                <div>
                    <p className="task_time" style={{textAlign:'right'}}>
                        {today.setHours(0,0,0,0) === new Date(ekbDate).setHours(0,0,0,0) 
                            ? ekbDate.toLocaleTimeString('ru-RU', {hour: '2-digit', minute: '2-digit'})
                            : ekbDate.toLocaleDateString('ru-RU') + ' ' + ekbDate.toLocaleTimeString('ru-RU', {hour: '2-digit', minute: '2-digit'})
                        }
                    </p>
                    <p className="task_done" style={{textAlign:'right'}}>
                        {job.volume}
                        <span style={{fontWeight:'100'}}> {job.unitOfMeasurementNameShort}</span>
                    </p>
                </div>
            </div>
        </div>
        );
    })}
    

    <Outlet />
    </>
    
  );
};

export default Home;